<template>
  <v-container
    class="pa-0"
    style="
      position: fixed;
      z-index: 999;
      background: #fff;
      bottom: 0;
      right: 20px;
      width: 600px;
      max-height: 700px;
    "
    v-if="editor_open"
  >
    <!-- FULL SCREEN -->
    <v-dialog v-model="editor_full_screen" persistent
      ><v-card>
        <v-container
          dark
          dense
          color="black"
          class="d-flex flex-row ma-0 red lighten-1 pa-0 justify-end align-content-center"
          fluid
        >
          <span class="white--text mr-auto ml-2 my-auto">Nova Menssagem</span>
          <v-btn icon class="ma-0" @click="toggleFullScreen">
            <v-icon v-if="editor_maximized" small color="white">mdi-window-minimize</v-icon>
            <v-icon v-else small color="white">mdi-window-maximize</v-icon>
          </v-btn>
          <v-btn icon @click="toggleFullScreen">
            <v-icon small color="white">mdi-arrow-collapse</v-icon>
          </v-btn>
          <v-btn icon @click="closeEditor">
            <v-icon small color="white">mdi-close</v-icon>
          </v-btn>
        </v-container>
        <v-container style="overflow-y: scroll" class="pa-0 px-2" v-if="editor_maximized" fluid>
          <v-container fluid>
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="ma-0 pa-0">
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="form.to_department"
                  label="Para departamentos"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" class="ma-0 pa-0">
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="form.to_employee"
                  label="Para funcionários"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="form.to_employee">
              <v-col cols="12" class="ma-0 pa-0">
                <v-combobox
                  v-model.trim="form.employees"
                  :items="employees"
                  item-value="id"
                  item-text="full_name"
                  label="Funcionários"
                  outlined
                  dense
                  multiple
                  clearable
                  class="m-0 p-0"
                  hide-details="auto"
                  :error-messages="erros.employees"
                  @change="checkCIErros()"
                  @input="comboboxCheckInput('employees')"
                >
                  <template v-slot:selection="{ item, index }">
                    <template v-if="index === 0">
                      <span>{{ item.full_name }}</span>
                    </template>

                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ form.employees.length - 1 }} outros)
                    </span>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="form.to_department">
              <v-col cols="12" class="ma-0 pa-0">
                <v-select
                  v-model.trim="form.workstation"
                  :items="workstations"
                  item-value="id"
                  item-text="workstation"
                  label="Vínculo"
                  outlined
                  dense
                  class="m-0 p-0"
                  :error-messages="erros.workstation"
                  @change="checkCIErros()"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="form.to_department">
              <v-col cols="12" class="ma-0 pa-0">
                <v-combobox
                  v-model.trim="form.departments"
                  :items="departments"
                  item-value="id"
                  item-text="department"
                  label="Departamentos"
                  outlined
                  dense
                  multiple
                  class="m-0 p-0"
                  clearable
                  :error-messages="erros.departments"
                  @change="checkCIErros()"
                  @input="comboboxCheckInput('departments')"
                >
                  <template v-slot:selection="{ item, index }">
                    <template v-if="index === 0">
                      <span>{{ item.department }}</span>
                    </template>

                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ form.departments.length - 1 }} outros)
                    </span>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0" v-if="form.to_department">
              <v-col class="ma-0 pa-0">
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="form.to_coordinator"
                  label="Para coordenador"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="form.message"
                  hide-details="auto"
                  outlined
                  full-width
                  no-resize
                  height="250px"
                  :error-messages="erros.message"
                  @change="checkCIErros()"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="ma-0 pa-0">
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="form.requires_signature"
                  label="Necessita de assinatura"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-btn color="green ligthen-1" class="white--text" @click="sendIC">Enviar</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card></v-dialog
    >

    <!-- LOW SCREEN -->
    <v-container
      class="d-flex flex-row red lighten-1 ma-0 pa-0 justify-end align-content-center"
      style="border-radius: 4px 4px 0 0"
      v-if="!editor_full_screen"
    >
      <span class="white--text mr-auto ml-2 my-auto">Nova Menssagem</span>
      <v-btn icon class="ma-0" @click="toggleEditor">
        <v-icon v-if="editor_maximized" small color="white">mdi-window-minimize</v-icon>
        <v-icon v-else small color="white">mdi-window-maximize</v-icon>
      </v-btn>
      <v-btn icon @click="toggleFullScreen">
        <v-icon small color="white">mdi-arrow-expand</v-icon>
      </v-btn>
      <v-btn icon @click="closeEditor">
        <v-icon small color="white">mdi-close</v-icon>
      </v-btn>
    </v-container>

    <v-container
      style="overflow-y: scroll"
      class="pa-0 px-2"
      v-if="editor_maximized && !editor_full_screen"
    >
      <v-container fluid>
        <v-row class="ma-0 pa-0">
          <v-col cols="6" class="ma-0 pa-0">
            <v-checkbox
              class="ma-0 pa-0"
              v-model="form.to_department"
              label="Para departamentos"
            ></v-checkbox>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-checkbox
              class="ma-0 pa-0"
              v-model="form.to_employee"
              label="Para funcionários"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="form.to_employee">
          <v-col cols="12" class="ma-0 pa-0">
            <v-combobox
              v-model.trim="form.employees"
              :items="employees"
              item-value="id"
              item-text="full_name"
              label="Funcionários"
              outlined
              dense
              multiple
              clearable
              class="m-0 p-0"
              hide-details="auto"
              :error-messages="erros.employees"
              @change="checkCIErros()"
              @input="comboboxCheckInput('employees')"
            >
              <template v-slot:selection="{ item, index }">
                <template v-if="index === 0">
                  <span>{{ item.full_name }}</span>
                </template>

                <span v-if="index === 1" class="grey--text caption">
                  (+{{ form.employees.length - 1 }} outros)
                </span>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="form.to_department">
          <v-col cols="12" class="ma-0 pa-0">
            <v-select
              v-model.trim="form.workstation"
              :items="workstations"
              item-value="id"
              item-text="workstation"
              label="Vínculo"
              outlined
              dense
              class="m-0 p-0"
              :error-messages="erros.workstation"
              @change="checkCIErros()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="form.to_department">
          <v-col cols="12" class="ma-0 pa-0">
            <v-combobox
              v-model.trim="form.departments"
              :items="departments"
              item-value="id"
              item-text="department"
              label="Departamentos"
              outlined
              dense
              multiple
              class="m-0 p-0"
              clearable
              :error-messages="erros.departments"
              @change="checkCIErros"
              @input="comboboxCheckInput('departments')"
            >
              <template v-slot:selection="{ item, index }">
                <template v-if="index === 0">
                  <span>{{ item.department }}</span>
                </template>

                <span v-if="index === 1" class="grey--text caption">
                  (+{{ form.departments.length - 1 }} outros)
                </span>
              </template>
            </v-combobox>
          </v-col>
        </v-row>

        <v-row class="ma-0 pa-0" v-if="form.to_department">
          <v-col class="ma-0 pa-0">
            <v-checkbox
              class="ma-0 pa-0"
              v-model="form.to_coordinator"
              label="Para coordenador"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="form.message"
              hide-details="auto"
              outlined
              full-width
              no-resize
              height="250px"
              :error-messages="erros.message"
              @change="checkCIErros()"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
            <v-checkbox
              class="ma-0 pa-0"
              v-model="form.requires_signature"
              label="Necessita de assinatura"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-btn color="green ligthen-1" class="white--text" @click="sendIC">Enviar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'NewCi',
  props: ['new_dialog', 'closeEditor', 'editor_open'],
  data: function () {
    return {
      dialog: true,
      editor_maximized: true,
      editor_full_screen: false,
      searchInput: '',
      form: {
        message: '',
        to_coordinator: false,
        departments: [],
        employees: [],
        requires_signature: false,
        workstation: '',
        to_department: false,
        to_employee: false,
      },
      erros: {
        invalid: false,
        departments: [],
        employees: [],
        workstation: [],
        message: [],
      },
    }
  },
  computed: {
    ...mapState('utils', ['departments', 'employees', 'workstations']),
    getStyle() {
      const full_screen = 'top:20px; left:20px; width:100vw; height:90vh;'
      const low_screen = ''
      return this.editor_full_screen ? full_screen : low_screen
    },
    to_department() {
      return this.form.to_department
    },
    to_employee() {
      return this.form.to_employee
    },
    form_employees() {
      return this.form.employees
    },
    form_departments() {
      return this.form.departments
    },
  },
  watch: {
    to_department() {
      if (this.form.to_department) {
        this.form.to_employee = false
      }
    },
    to_employee() {
      if (this.form.to_employee) {
        this.form.to_department = false
      }
    },
  },
  methods: {
    ...mapActions('ci', ['ActionStoreIC']),
    ...mapActions('ui', ['ActionSetLoading']),
    comboboxCheckInput(key) {
      this.form[key] = this.form[key].filter((item) => typeof item == 'object')
    },
    toggleEditor() {
      this.editor_maximized = !this.editor_maximized
    },
    toggleFullScreen() {
      this.editor_full_screen = !this.editor_full_screen
      this.editor_maximized = true
    },
    async sendIC() {
      this.ActionSetLoading(true)
      try {
        this.checkCIErros()
        if (this.erros.invalid) {
          this.$swal({
            icon: 'warning',
            title: 'Atenção',
            text: 'Há campos obrigatórios não preenchidos!',
          })
        } else {
          await this.ActionStoreIC({
            ...this.form,
            message: this.form.message.replace(/\n/g, '<br />'),
          })
          this.$swal({
            icon: 'success',
            title: 'Enviado',
            text: 'Comunicação Interna enviada com sucesso!',
          })
          this.cleanForm()
        }
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
    checkCIErros() {
      this.erros.invalid = false
      if (this.to_employee) {
        if (this.form.employees.length == 0) {
          this.erros.employees = ['Selecione pelo menos um funcionário']
          this.erros.invalid = true
        } else {
          this.erros.employees = []
        }
      }
      if (this.to_department) {
        if (this.form.departments.length == 0) {
          this.erros.departments = ['Selecione pelo menos um departamento']
          this.erros.invalid = true
        } else {
          this.erros.departments = []
        }
        if (this.form.workstation == '') {
          this.erros.workstation = ['Selecione o Vínculo']
          this.erros.invalid = true
        } else {
          this.erros.workstation = []
        }
      }
      if (this.form.message == '') {
        this.erros.message = ['A mensagem não pode ser vazia']
        this.invalid = true
      } else {
        this.erros.message = []
      }
    },
    cleanForm() {
      this.form = {
        message: '',
        to_coordinator: false,
        departments: [],
        employees: [],
        requires_signature: false,
        workstation: '',
        to_department: false,
        to_employee: false,
      }
    },
  },
}
</script>
